import Campus from "./Campus";
import {Dayjs} from "dayjs";

class Casal {
    constructor(
        public key: number = 0,
        public id: number = 0,
        public nom: string = "",
        public estat: number = 0,
        public inici: string | Dayjs = "",
        public fin: string | Dayjs  = "",
        public id_escola_entrada1: number | null = 0,
        public id_escola_entrada2: number | null = 0,
        public descripcio: string = "",
        public children: Campus[] = []
    ) {}
}

export default Casal;